import React from "react";
import "./Home_OverviewComp.css";
import SkillImg from "../../resource/Inner/Skill.jpeg";
import { useInView } from "react-intersection-observer";

const HomeOverviewComp = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0,
  });
  return (
    <>
      <section
        className={`overviewcontent container transition-all ${
          inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-48"
        } duration-700`}
        ref={ref}
      >
        <div className="paragraph">
          <h1 className="sec_heading">Overview</h1>
          <p>
            At Sampurna, we're dedicated to empowering individuals from
            low-income backgrounds by providing them with skill development
            training programs. Our mission is to address the root causes of
            poverty and poor living standards, helping individuals discover
            their passions and unlock their entrepreneurial potential. With a
            focused approach, we've witnessed remarkable transformations. A
            small spark of encouragement can awaken their inner drive, enabling
            them to break free from the cycle of poverty. By supporting hundreds
            of families in turning their dreams into reality, Sampurna is
            committed to creating a brighter future for all.
          </p>
          {/* <p>
            Sampurna believes in providing the members of the lower income group
            of our society with skill development training programmes, to
            support them in healing the root cause of their poor standard of
            living by helping them realize their interests is also imperative.
            We have witnessed that with a small impetus to awake their
            entrepreneurial intent and skills; and with a little push, they gain
            the ability to jump over the traditional 'poverty trap'. Sampurna
            has enabled hundreds of families to dream and eventually turn those
            dreams into reality.
          </p> */}
        </div>
        <div className="overview_img">
          <img src={SkillImg} alt="Sills" />
        </div>
      </section>
    </>
  );
};

export default HomeOverviewComp;
